import React, { useState } from "react"
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FormValidator from "../../utils/FormValidator"
import NotificationHandler from "../../utils/NotificationHandler"
import { enumUtil } from "../../utils/Enum"
import { ServerRequestProtected } from "../../utils/ServerDataRequest"
import Loader from "../shared/Loader/Loader"
import { ConstructionOutlined, Email, Password } from "@mui/icons-material";
import { Link } from "react-router-dom";


const ChangePassword = (props) => {
    const API_URL = enumUtil.controller.Login
    const year = new Date().getFullYear();

    let navigate = useNavigate();
    let changepassword_Modal = {
        Password: "",
        ConfirmPassword: "",
    }
    let valModal = {}

    let ValidationModal = {
        PasswordVal: "",
        PasswordDigitsVal: "",
        ConfirmPasswordVal: "",
        ConfirmPasswordDigitsVal: "",
    }
    const [isLoading, setIsLoading] = useState(false)
    const [mainchangepasswordModal, setmainchangepasswordModal] = useState(changepassword_Modal);
    const [changepasswordSaveUpdateModal, setchangepasswordSaveUpdateModal] = useState({});
    const [changepasswordValidationModal, setchangepasswordValidationModal] = useState(ValidationModal)
    const [comparepasswordValidation, setComparepasswordValidation] = useState(false)
    const [hidePwd, setHidePwd] = useState(true);
    const [hideCnfrmPwd, setHideCnfrmPwd] = useState(true);

    const handlechangepasswordChange = (e) => {
        let { name, value } = e.target;
        let modal = { ...mainchangepasswordModal };
        let saveModal = { ...changepasswordSaveUpdateModal }
        modal[name] = value
        setmainchangepasswordModal(modal)
        for (var property in changepassword_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setchangepasswordSaveUpdateModal(saveModal)
    }

    const changepasswordValidation = async () => {
        let ValidationModal = {
            PasswordVal: FormValidator(
                mainchangepasswordModal.Password,
                enumUtil.enumValidationType.Required,
                'Password',
            ),
            PasswordDigitsVal: FormValidator(
                mainchangepasswordModal.Password,
                enumUtil.enumValidationType.Password,
                'Password',
            ),
            ConfirmPasswordVal: FormValidator(
                mainchangepasswordModal.ConfirmPassword,
                enumUtil.enumValidationType.Required,
                'Confirm Password',
            ),
            ConfirmPasswordDigitsVal: FormValidator(
                mainchangepasswordModal.ConfirmPassword,
                enumUtil.enumValidationType.Password,
                'Confirm Password',
            ),
        }
        await setchangepasswordValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const ComparepasswordValidation = async () => {
        if (mainchangepasswordModal.Password !== mainchangepasswordModal.ConfirmPassword) {
            await setComparepasswordValidation(true)
            return true
        }
        else {
            await setComparepasswordValidation(false)
            return false
        }
    }
    // const hideshow =() =>{
    //     console.log(hidePwd)
    //     setHidePwd(!hidePwd);
    // }

    const [agreeToTerms, setAgreeToTerms] = useState(false);

    // Add this function to handle checkbox change
    const handleAgreeToTerms = (e) => {
        const checked = e.target.checked;
        setAgreeToTerms(checked);
    }
    const handleSubmit = async (event) => {
        await changepasswordValidation()
        let compareValidation = await ComparepasswordValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            // console.log("valModal", valModal);
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else if (compareValidation == false && validation == false) {
            if (!agreeToTerms) {
                NotificationHandler('Please agree to the Privacy Policy and Terms of Service', enumUtil.enumtoaster.error)
                return
            }
            console.log("Accept")
            let data = { ...changepasswordSaveUpdateModal, "IsPolicyAgreed": agreeToTerms }
            // console.log("obj", ...data,);
            var url = window.location.href;
            const urlParts = url.split('?');
            const params = urlParts[1].split('&');

            var obj = {};
            for (var i in params) {
                const keyValues = params[i].split('=');
                const newItemInput = keyValues[0];
                const newRadioValue = keyValues[1];
                obj[newItemInput] = newRadioValue;
            }
            if (obj) {

                 setIsLoading(true)
                ServerRequestProtected(API_URL + "/ResetPassword", 'post', {
                    ...data, ...obj
                }).then((response) => {
                    setIsLoading(false)
                    event.preventDefault();
                    navigate("../", { replace: true });
                    NotificationHandler('Changed Successfully', enumUtil.enumtoaster.success)
                    navigate("../resetsuccessfull", { replace: true })
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error.response.data);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
            }
        }
    }
        const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <React.Fragment >
            {/* {isLoading ? <Loader /> : null} */}
            {/* 
            <div className="login">
                <div className="d-lg-flex half overflow-hidden za-half">
                    <div className="bg order-1 order-md-2">
                        <img src={process.env.PUBLIC_URL + "/assets/images/v2LoginHMS.jpg"} alt="" />
                    </div>
                    <div className="contents order-2 order-md-1">
                        <h1 className="hk-title mt-4">Practice Management System</h1>
                        <div className="container mt-3">
                            <div className="row align-items-start justify-content-center">
                                <div className="col-md-10">
                                    <div className="hk-t-img">
                                        <img src={process.env.PUBLIC_URL + "/assets/images/lock-password.png"} alt="forget password icon" />
                                    </div>
                                    <h2 class="heading xl text-center mb-1">Set new password</h2>
                                    <p className="text fs-11 clr-muted forget- mb-10 text-center">Your new password must be different to previously used passwords</p>

                                    {changepasswordValidationModal.PasswordDigitsVal || changepasswordValidationModal.ConfirmPasswordDigitsVal ?
                                        <div className={"text fs-11 forget-p rest-pswd-sc za-red-clr mt-10"}>
                                            {changepasswordValidationModal.PasswordDigitsVal || changepasswordValidationModal.ConfirmPasswordDigitsVal}
                                        </div> : null}
                                    <div className="mt-4">
                                        <div className={changepasswordValidationModal.PasswordVal ? "form-group input mt-0 mb-3 hk-password-field error" : changepasswordValidationModal.PasswordDigitsVal ? "form-group input mt-0 mb-3 hk-password-field error" : "form-group input mt-0 mb-3 hk-password-field"}>
                                            <label ><b>Password</b></label>
                                            <input type={hidePwd ? "password" : "text"}
                                                className="form-control"
                                                name="Password"
                                                id="Password"
                                                value={mainchangepasswordModal.Password}
                                                onChange={handlechangepasswordChange}
                                            />
                                            <div className="hk-eye-btn"
                                                onMouseDown={() => setHidePwd(false)}
                                                onMouseUp={() => setHidePwd(true)}
                                                onMouseLeave={() => setHidePwd(true)}
                                            >
                                                {hidePwd ? <i class="icon-eye-blocked"></i> : <i class="icon-eye"></i>}
                                            </div>
                                            {changepasswordValidationModal.PasswordVal}
                                        </div>

                                        <div className={changepasswordValidationModal.ConfirmPasswordVal ? "form-group input mt-0 mb-3 hk-password-field error" : changepasswordValidationModal.ConfirmPasswordDigitsVal ? "form-group input mt-0 mb-3 hk-password-field error" : "form-group input mt-0 mb-3 hk-password-field"}>
                                            <label><b>Confirm Password</b></label>
                                            <input type={hideCnfrmPwd ? "password" : "text"}
                                                className="form-control"
                                                name="ConfirmPassword"
                                                id="ConfirmPassword"
                                                value={mainchangepasswordModal.ConfirmPassword}
                                                onChange={handlechangepasswordChange}
                                            />
                                            <div className="hk-eye-btn"
                                                onMouseDown={() => setHideCnfrmPwd(false)}
                                                onMouseUp={() => setHideCnfrmPwd(true)}
                                                onMouseLeave={() => setHideCnfrmPwd(true)}
                                            >
                                                {hideCnfrmPwd ? <i class="icon-eye-blocked"></i> : <i class="icon-eye"></i>}
                                            </div>
                                            {changepasswordValidationModal.ConfirmPasswordVal}
                                        </div>

                                        <div className={comparepasswordValidation ? "form-group input error" : "form-group input "}>
                                            {
                                                !changepasswordValidationModal.PasswordVal && !changepasswordValidationModal.PasswordDigitsVal
                                                    && !changepasswordValidationModal.ConfirmPasswordVal && !changepasswordValidationModal.ConfirmPasswordDigitsVal
                                                    && comparepasswordValidation ? (
                                                    <label>Password and Confirm Password must be same</label>
                                                ) : ""
                                            }
                                        </div>
                                        <input type="submit" value="Reset Password" className="btn rounded btn-blue w-100 mt-3 reset-pass-btn" onClick={handleSubmit} />
                                    </div>
                                    <a className="d-block text text-center inst-txt mt-4 text-decoration-none" onClick={() => navigate("../", { replace: true })}><span class="icon-Icon-ionic-md-arrow-round-back"></span> Back to Login</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="ar_login-screen">
                <div className="ar-main-screen-content w-100 d-flex align-items-center flex-column gap-25 justify-content-center">
                    <div className="login-content">
                        <div className="img-container h-auto s-70 mx-auto mb-15">
                            <img src={process.env.PUBLIC_URL + "/assets/images/lock-password.png"} alt="" />
                        </div>
                        <div className="mb-2 d-flex flex-column align-items-center">
                            <p className='fs-20 heading lh-normal'>Set new password</p>
                            <p className='text fs-11 color-muted lh-normal'>Your new password must be different to previously used password</p>
                            {changepasswordValidationModal.PasswordDigitsVal || changepasswordValidationModal.ConfirmPasswordDigitsVal ?
                                <div className={"text forget-p rest-pswd-sc za-red-clr Denied-clr mt-2"}>
                                    {changepasswordValidationModal.PasswordDigitsVal || changepasswordValidationModal.ConfirmPasswordDigitsVal}
                                </div> : null}
                        </div>
                        <div className="d-flex flex-column gap-20 br-bottom-1 za_br_light pb-4 mb-4">
                            <div className={changepasswordValidationModal.PasswordVal ? "form-group input hk-password-field error m-0" : changepasswordValidationModal.PasswordDigitsVal ? "form-group input m-0 hk-password-field error" : "form-group input m-0 hk-password-field"}>
                                <label >Password</label>
                                <div className="position-relative">
                                    <input type={hidePwd ? "password" : "text"}
                                        className="form-control"
                                        name="Password"
                                        id="Password"
                                        value={mainchangepasswordModal.Password}
                                        onChange={handlechangepasswordChange}
                                    />
                                    <div className="hk-eye-btn top-50 translate-middle-y" onMouseDown={() => setHidePwd(false)} onMouseUp={() => setHidePwd(true)} onMouseLeave={() => setHidePwd(true)}>
                                        {hidePwd ? <i class="icon-eye-blocked"></i> : <i class="icon-eye"></i>}
                                    </div>
                                    {changepasswordValidationModal.PasswordVal}
                                </div>
                            </div>

                            <div className={changepasswordValidationModal.ConfirmPasswordVal ? "form-group input m-0 hk-password-field error" : changepasswordValidationModal.ConfirmPasswordDigitsVal ? "form-group input m-0 hk-password-field error" : "form-group input m-0 hk-password-field"}>
                                <label>Confirm Password</label>
                                <div className="position-relative">
                                    <input type={hideCnfrmPwd ? "password" : "text"}
                                        className="form-control"
                                        name="ConfirmPassword"
                                        id="ConfirmPassword"
                                        value={mainchangepasswordModal.ConfirmPassword}
                                        onChange={handlechangepasswordChange}
                                    />
                                    <div className="hk-eye-btn top-50 translate-middle-y" onMouseDown={() => setHideCnfrmPwd(false)} onMouseUp={() => setHideCnfrmPwd(true)} onMouseLeave={() => setHideCnfrmPwd(true)}>
                                        {hideCnfrmPwd ? <i class="icon-eye-blocked"></i> : <i class="icon-eye"></i>}
                                    </div>
                                    {changepasswordValidationModal.ConfirmPasswordVal}
                                </div>
                            </div>
                            <div className='d-flex align-items-center gap-2'>
                                <label className="custom_check_box d-flex align-items-center gap-2 m-0">
                                    <input
                                        type="checkbox"
                                        className="form-check-input m-0 p-0"
                                        name='IsPolicyAgreed'
                                        id='IsPolicyAgreed'
                                        checked={agreeToTerms}
                                        onChange={handleAgreeToTerms}
                                    />
                                    <p className="text fs-11 user-select-none m-0">
                                        I agree to the   <a href="https://starhealthcare.co/PrivacyPolicy" target="_blank" className="link-orange text-decoration-none">Privacy Policy</a> and{' '}

                                        <a href="https://starhealthcare.co/TermsOfService" target="_blank" className="link-orange text-decoration-none">Terms of Service </a> for my account.


                                    </p>
                                </label>
                            </div>

                            {!changepasswordValidationModal.PasswordVal && !changepasswordValidationModal.PasswordDigitsVal && !changepasswordValidationModal.ConfirmPasswordVal && !changepasswordValidationModal.ConfirmPasswordDigitsVal && comparepasswordValidation ? (
                                <div className={comparepasswordValidation ? "form-group input error m-0" : "form-group input m-0"}>
                                    <label>Password and Confirm Password must be same</label>
                                </div>
                            ) : null}

                            <div className='position-relative login-btn-loader'>
                                <input type="submit" value={`${isLoading === true ? '' : 'Reset password'}`} className="btn rounded btn-orange heading w-100" onClick={handleSubmit} />

                                {isLoading === true ?
                                    <div className='last_loader ar-small-loader'>
                                        <div className="circle circle1"></div>
                                        <div className="circle circle2"></div>
                                    </div> :
                                    null}
                            </div>

                            <a className="text text-center inst-txt text-decoration-none" onClick={() => navigate("../", { replace: true })}><span class="icon-Icon-ionic-md-arrow-round-back fs-9"></span> Back to Login</a>
                        </div>

                        <div className="d-flex align-items-center justify-content-center">
                            <p className='text fs-12 color-95 '>©{year} {ThemeConfiguration?.configuration?.company?.name}. All rights reserved</p>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
export default ChangePassword